import { Translatable } from "@icc/shared/helpers";

export class HorizontalBoxReinforcement {
    id: number;
    /** Kod zewnętrzny */
    extId: string;
    /** Kod do indeksu */
    indexNo: string;
    /** Nazwa (pole językowe) - wyświetlane w konfiguratorze */
    @Translatable({ model: 'Profiles' })
    name: string;
    /** Nazwa systemowa */
    nameCms: string;
    /** Kod do wydruków */
    printCode: string;
    /** Typy produktów */
    shutterTypes: number[];
    /** Zdjęcie */
    img: string;
    /** Opis */
    description: string;
    /** Moskitiera */
    mosquitoCompatibility: 'independent' | 'unavailable_with_rolled' | 'only_with_rolled';
    /** IDs profili skrzynek, z którymi jest kompatybilny */
    compatibleBlindBoxProfilesIds: string[];
    /** Czy domyślny */
    isDefault?: boolean;
    /** Czy wzmocnienie dolnej części skrzynki */
    isBottomBoxReinforcement?: boolean;
    /** Ograniczenia wymiarowe */
    ranges: {
        /** Minimalna szerokość [mm] */
        min_width: number;
        /** Maksymalna szerokość [mm] */
        max_width: number;
        /** Typ wyboru */
        selection_type?: 'mandatory' | 'suggested' | 'optional';
        /** Czy wyświetlać komunikat o dostępności */
        show_selection_type_announcement?: boolean;
    }[];
}
